import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { FiltroProdutosUsuario } from '@core/models/consulta-metodo.models';
import { RamosMenuEnum } from '@core/models/ramo.models';
import { StatusRamoEnum } from '@core/models/status-ramo.models';
import { StepsTourEnum } from '@core/models/tour.models';
import { DashboardService } from '@core/services/dashboard.service';
import { NotificationService } from '@core/services/notification.service';
import { ParametroPortalService } from '@core/services/parametro-portal.service';
import { RamoService } from '@core/services/ramo.service';
import { MatPageable } from '@core/table/mat-table';
import { environment } from '@env/environment';
import {
  faBuilding,
  faCar,
  faClipboardList,
  faCogs,
  faDesktop,
  faFileSignature,
  faHome,
  faReceipt,
  faStar,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { ContatoComponent } from '@modules/contato/contato.component';
import { SobreComponent } from '@modules/sobre/sobre.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JoyrideService } from 'ngx-joyride';
import { AppSharedDataService } from 'src/app/app-shared-data.service';
import { HeaderSharedDataService } from '../header/header-shared-data.service';
import { StorageService } from '@shared/utils/services/storage.service';
import { EStorage } from '@shared/utils/enums/storage.enum';
import moment from 'moment';
import { Perfil, PerfilEnum } from '@core/models/perfil.models';
import { DocRouteService } from '../../../modules/docs/doc-route.service';
import { UsuarioService } from '@core/services/usuario.service';

export class ItemMenuBoostrap {
  nome: string;
  rota?: any;
  subItens?: ItemMenuBoostrap[];
  open?: boolean;
  icone?: any;
  permissao?: string[];
  ativo?: boolean;
  menuAtivo?: boolean;
  linkExterno?: string;
  svg?: string;
  breadCrumb?: any;
  rotaRamo?: string;
  id?: number;
}

@Component({
  selector: 'app-menu-boostrap',
  templateUrl: './menu-boostrap.component.html',
  styleUrls: ['./menu-boostrap.component.scss']
})
export class MenuBoostrapComponent implements OnInit, AfterViewInit {

  menu: ItemMenuBoostrap[];
  faHome = faHome;
  faUsers = faUsers;
  faBuilding = faBuilding;
  faFileSignature = faFileSignature;
  faCogs = faCogs;
  faReceipt = faReceipt;
  faStar = faStar;
  faClipboardList = faClipboardList;
  faCar = faCar;
  faDesktop = faDesktop;
  @ViewChild("sidebar") sidebar;
  versao: string;
  active: boolean;
  searchVisible: boolean;
  menuMobile: any;
  menuOver: boolean = false;
  subMenuAtivo: any;
  subMenuAtivoBoolean: boolean = false;
  subMenuAtivoOpen: boolean = false;
  menuUsuarioAtivo: boolean = false;
  ramos: any[] = [];
  meusProdutosGroup: any[] = [];
  menuFinal: any[] = [];
  filtro: FiltroProdutosUsuario;
  pageableProduto = new MatPageable(0, 999);
  linkActive: any;

  tour: boolean;
  propertyTourId: number = 37;
  arrayStepTour = 0;
  stepsTour: any;
  stepsJson: any;
  stepTour: string;
  titleTour: string;
  descriptionTour: string;
  counterSteps: number = 0;

  menuDashboard: boolean = false;
  ramoActive: any;

  produtoAtivo: boolean = false;
  paginasAgrupadasPbi: any;
  produtosMenuPowerBi: any[] = [];
  isPainelDashboard: boolean;
  subItemPbi: any;
  metodoAtivo: any;
  produtosMenuDashboardAntifraude: any[] = [];
  produtosMenuDashboardSti: any[] = [];
  produtosMenuDashboardSia: any[] = [];
  produtosMenuGrupoAssinaturasSti: any[] = [];
  menuComissaoSti: any[] = [];
  ramoGrupoStiAberto: string;
  linkGrupoSti: string = sessionStorage.getItem('reportNameDBStiGrupo');

  numeroPerfil: PerfilEnum = PerfilEnum.Desenvolvedor
  perfilEnum = PerfilEnum;

  isProdutoSti: boolean = false;

  // Dev Portal Menu
  // Dev Portal Menu
  allowedDevPortalMenus = {
    ramoIds: [RamosMenuEnum.Automovel, RamosMenuEnum.Habitacional, RamosMenuEnum.Multiramo, RamosMenuEnum.Transporte, RamosMenuEnum.Vida, RamosMenuEnum.Saude],
    produtoIds: [46, 90, 91, 100, 24, 89, 52, 57, 36, 7, 63, 38, 11, 42, 14, 44, 79, 108, 109, 110, 111, 112, 25, 13, 34, 96, 53, 30, 8, 999, 998, 78, 10, 5, 93, 76, 2, 39, 6, 1, 47, 49]
  }

  docsRoutes = {
    46: '/assets/docs/devportal/RNPA Auto/index.html',
    90: '/assets/docs/devportal/Socioambiental/index.html',
    91: '/assets/docs/devportal/Risco-Climatico/index.html',
    100: '/assets/docs/devportal/RNPA Transporte/index.html',
    24: '/assets/docs/devportal/RNS-Auto/index.html',
    89: '/assets/docs/devportal/rnpa-pessoas/index.html',
    52: '/assets/docs/devportal/BAJ/index.html',
    57: '/assets/docs/devportal/Base-Licenciamento/index.html',
    36: '/assets/docs/devportal/SNG/index.html',
    7: '/assets/docs/devportal/SICON/index.html',
    63: '/assets/docs/devportal/EV/index.html',
    38: '/assets/docs/devportal/Recall/index.html',
    11: '/assets/docs/devportal/BDV/index.html',
    42: '/assets/docs/devportal/SIBLOQ/index.html',
    14: '/assets/docs/devportal/SIPLAV-DCF/index.html',
    44: '/assets/docs/devportal/SIPLAV-DCF+PEP/index.html',
    79: '/assets/docs/devportal/SCCP/index.html',
    108: '/assets/docs/devportal/RNS-Patrimonial/index.html',
    109: '/assets/docs/devportal/RNS-Transporte/index.html',
    110: '/assets/docs/devportal/RNS - Créditos e Garantias/index.html',
    111: '/assets/docs/devportal/RNS-Rural/index.html',
    112: '/assets/docs/devportal/RNS-Pessoas/index.html',
    25: '/assets/docs/devportal/RENAVAM BIN FABRIL/index.html',
    13: '/assets/docs/devportal/RENAVAM BIN RF/index.html',
    34: '/assets/docs/devportal/RENAVAM BASE ESTADUAL/index.html',
    96: '/assets/docs/devportal/SIVVE Premium/index.html',
    53: '/assets/docs/devportal/SIVVE/index.html',
    30: '/assets/docs/devportal/SINOB/index.html',
    8: '/assets/docs/devportal/RENACH/index.html',
    999: '/assets/docs/devportal/Central de Bonus/index.html',
    998: '/assets/docs/devportal/RNS/index.html',
    78: '/assets/docs/devportal/RNS-Coincidencias/index.html',
    10: '/assets/docs/devportal/TabelaFipe/index.html',
    5: '/assets/docs/devportal/Correio-Base-DNE/index.html',
    93: '/assets/docs/devportal/Assistência 24h/index.html',
    76: '/assets/docs/devportal/Experiência em riscos diversos/index.html',
    2: '/assets/docs/devportal/BDRF/index.html',
    39: '/assets/docs/devportal/MarcaModelo/index.html',
    6: '/assets/docs/devportal/DPVAT-Bilhete/index.html',
    1: '/assets/docs/devportal/BDSII/index.html',
    47: '/assets/docs/devportal/CentralBonus/index.html',
    49: '/assets/docs/devportal/Ressarcimento/index.html'
  }



  @HostListener('document:click', ['$event'])
  handleClick(event) {
    this.createBorder(event);
  }

  @Output() menuLoaded = new EventEmitter<boolean>()

  constructor(
    private router: Router, private modalService: NgbModal,
    private appSharedDataService: AppSharedDataService,
    private authenticationService: AuthenticationService,
    private headerSharedDataService: HeaderSharedDataService,
    private ramoService: RamoService,
    private notificationService: NotificationService,
    private joyrideTour: JoyrideService,
    private parametroPortalService: ParametroPortalService,
    private dashboardService: DashboardService,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private _docRouteService: DocRouteService,
    public usuarioService: UsuarioService
  ) {
  }

  ngOnInit() {

    this.numeroPerfil = String(this.authenticationService.currentUserValue.id_perfil) as PerfilEnum

    this.filtro = {};
    this.versao = environment.version;
    this.validateTour();

    this.headerSharedDataService.searchVisible$.subscribe((data) => this.searchVisible = data);
    this.appSharedDataService.menuBootstrap$.subscribe((data) => {
      this.meusProdutosGroup = JSON.parse(JSON.stringify(data));
      this.addMenuDevPortalItems(this.meusProdutosGroup);
    });
    this.appSharedDataService.resetMenuBootstrap$.subscribe((res) => {
      if (res)
        this.linkActive = undefined;
      this.subMenuAtivoOpen = this.subMenuAtivoBoolean = false;
      this.meusProdutosGroup.forEach(x => x.open = false);
    });

    this.produtosMenuPowerBi = this.dashboardService.powerBiMenu
    this.produtosMenuDashboardAntifraude = this.dashboardService.dashboardAntifraudeMenu
    this.produtosMenuDashboardSti = this.dashboardService.dashboardStiMenu
    this.produtosMenuDashboardSia = this.dashboardService.dashboardSiaMenu
    this.produtosMenuGrupoAssinaturasSti = this.dashboardService.grupoAssinaturasStiMenu
    this.menuComissaoSti = this.dashboardService.comissaoStiMenu

    this.ramoService.getRamos(new MatPageable(), { idStatus: StatusRamoEnum.Ativo }).subscribe((data) => {
      this.ramos = data;
      this.buscarProdutosPorRamo(data);
    })

    this.appSharedDataService.metodoAtivo$.subscribe(res => {
      if (res) {

        this.linkActive = res.metodo;
        (res.ramo.length == 1) ? res.ramo = this.ramos.find(x => x.id == res.ramo) : null;
        this.goToRoute(res.ramo, res.produto);
      }
    })

    if (!this.linkActive) {
      this.appSharedDataService.ramoAtivo$.subscribe(res => {
        if (typeof res === 'object') {
          this.subMenuAtivoOpen = this.subMenuAtivoBoolean = false;
          this.meusProdutosGroup.find(x => x.id == res.id).open = true;
          this.meusProdutosGroup.filter(x => x.id != res.id).forEach(x => x.open = false);
        } else {
          let ramoAtual = this.ramos.find(x => x.id == res)
          this.subMenuAtivoOpen = this.subMenuAtivoBoolean = false;
          this.meusProdutosGroup.filter(x => x.id != ramoAtual.id).forEach(x => x.open = false);
        }
      })
    }

    this.appSharedDataService.pagePbiChangedNext$.subscribe(res => {
      this.subItemPbi = res;
    })

    this.appSharedDataService.pagePbiChangedPrevious$.subscribe(res => {
      this.subItemPbi = res;
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.borderTour();
    }, 10)

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url) {
        this.activateMenu(event.url)
      }
    })
  }

  // Verifica a URL e seta o menu ativo
  activateMenu(url: string) {
    const regexConsultaProdutoMetodo = /\/consulta\/(\d+)\/(\d+)\/(\d+)\//;

    const matches = url.match(regexConsultaProdutoMetodo);
    const isConsulta = url.includes('consulta')
    let ramoId: string
    let produtoId: string
    let metodoId: string

    if (isConsulta && matches) {
      ramoId = matches[1]
      produtoId = matches[2]
      metodoId = matches[3]

      const ramoGrupoSti = this.produtosMenuGrupoAssinaturasSti[0].subItem.find(el => el.nameReport == metodoId)
      if (ramoGrupoSti) this.ramoGrupoStiAberto = ramoGrupoSti.nomePagina
      this.linkGrupoSti = sessionStorage.getItem('reportNameDBStiGrupo')

      const ramo = this.meusProdutosGroup.find(ramo => ramo.id == ramoId)
      const produto = ramo?.produtos.find(produto => produto.idProduto == produtoId)
      const metodo = produto.metodos.find(metodo => metodo.id == metodoId)

      this.appSharedDataService.setMetodoAtivo({ ramo: ramo, produto: produto, metodo: metodo });
    }

  }

  // Abre a rota do método
  goToMetodo(subMenuAtivo, metodo) {
    if (!metodo.acesso) return
    
    const activeRamo = this.meusProdutosGroup.find(el => el.open)
    this.router.navigate(['/consulta', activeRamo.id, subMenuAtivo.idProduto, metodo.id, subMenuAtivo.dsServico, metodo.dsMetodo], { queryParams: { favorito: subMenuAtivo.favorito } });
  }

  toogleItem(ramo: ItemMenuBoostrap) {
    ramo.open = !ramo.open;
    this.meusProdutosGroup.filter(x => x.nome != ramo.nome).forEach(x => x.open = false);
    this.appSharedDataService.setRamoAtivo(ramo.id);
    ramo.open ? this.goToProdutos(ramo) : null;
  }

  goToRoute(ramo: any, produto: any) {

    if (this.authenticationService.currentUser['devMode'] == true) {
      this._docRouteService.emitUrl(this.docsRoutes[produto.idProduto])
      produto['ativo'] = true
      return
    }
    produto?.idProduto == 106 ? this.isProdutoSti = true : this.isProdutoSti = false;
    this.isPainelDashboard = false;
    this.subItemPbi = undefined;
    if (ramo.id == RamosMenuEnum.Automovel || ramo.id == RamosMenuEnum.Multiramo || ramo.id == RamosMenuEnum.Antifraude) {
      if (produto != undefined && produto.idProduto && (produto.idProduto == 80 || produto.idProduto == 85 || produto.idProduto == 106 || produto.idProduto == 107)) {
        this.isPainelDashboard = true;
        if (this.linkActive) {
          if (this.linkActive.subItem) {
            this.subItemPbi = this.linkActive.subItem.subItem[0].nameReport;
          } else {
            let linkActive = this.produtosMenuPowerBi.find((x: any) => x.id == this.linkActive.id);
            if (linkActive) {
              this.subItemPbi = linkActive.subItem[0].nameReport;
            }
          }
        }
      } else {
        this.isPainelDashboard = false;
      }
    }
    let produtoAtivo;
    this.meusProdutosGroup.forEach(x => {
      if (ramo && !produto) {
        ramo.open = true;
        this.meusProdutosGroup.filter(x => x.nome != ramo.nome).forEach(x => x.open = false);
      }
      if (x.produtos) {
        if (x.nome == ramo.nome && produto) {

          if (this.linkActive) {
            x.produtos.find(s => {
              if (s.idProduto == produto.idProduto) {
                if (!produto.ativo) {
                  produto.ativo = false;
                  produtoAtivo = false;
                  this.produtoAtivo = produtoAtivo;
                }
              }
            })
          }
          x.produtos.filter(y => y.idProduto != produto.idProduto).forEach(y => y.ativo = false);
          if (produto.idProduto == 80) {
            this.adicionarMenuPowerBi(produto);
          } else if (produto.idProduto == 85) {
            this.addMenuDashboardAntifraude(produto);
          } else if (produto.idProduto == 106) {
            this.addMenuDashboardSti(produto);
          } else if (produto.idProduto == 107) {
            this.addMenuDashboardSia(produto)
          }
          this.subMenuAtivo = produto;
        }
        else {
          x.ativo = false;
          x.produtos.forEach(i => i.ativo = false);
        }
      }
    })

    if (ramo) {
      this.meusProdutosGroup.find(x => x.nome == ramo.nome ? x.open = true : x.open = false);
    }

    if (this.subMenuAtivo) {
      if (!this.menuMobile && !produtoAtivo)
        this.subMenuAtivoBoolean = (this.subMenuAtivoOpen = true);

      if (this.menuOver)
        this.subMenuAtivoBoolean = (this.subMenuAtivoOpen = true);
    }


  }

  goToRouteSubAtivo(menu: any, item: any, subItem: any): void {
    subItem.open = !subItem.open;
    menu.subItens.forEach(x => {
      if (x.nome == item.nome && subItem) {
        x.subItens.find(s => s.nome == subItem.nome ? subItem.open = true : subItem.open = false);
        x.subItens.filter(y => y.nome != subItem.nome).forEach(y => y.open = false);
      }
      else {
        x.ativo = false;
        if (x.subItens)
          x.subItens.forEach(i => i.open = false);
      }
    });
    this.router.navigate(subItem.rota)
  }

  goToDashboard(produto: any, metodo: any, subItem: any) {
    this.appSharedDataService.setPaginaPbi(subItem);
    if (produto.idProduto == 80) {
      sessionStorage.setItem('reportNamePBI', subItem.nameReport)
    }
    if (produto.idProduto == 85) {
      sessionStorage.setItem('reportNameDBAntifraude', subItem.nameReport);
    }

    if (produto.idProduto == 106) {
      sessionStorage.setItem('reportNameDBSti', subItem.nameReport);
    }

    if (produto.idProduto == 107) {
      sessionStorage.setItem('reportNameDBSia', subItem.link);
    }

    this.goToConsulta(produto, metodo, subItem);
  }

  toogleMenu(): void {
    const arrayDeElementos = Array.from(this.sidebar.nativeElement.childNodes);
    const conteudoMenu = arrayDeElementos.find((elemento: HTMLElement) => elemento.classList.contains('conteudo-menu')) as HTMLElement;
    this.sidebar.nativeElement.classList.toggle("active");
    this.appSharedDataService.setToogleMenu();
    this.active = this.sidebar.nativeElement.classList.contains("active");
    if (this.active) {
      conteudoMenu.style.setProperty('overflow-y', 'initial', 'important')
    } else {
      conteudoMenu.style.removeProperty('overflow-y')
    }
    this.menuMobile = !this.menuMobile;
    this.subMenuAtivoBoolean ? (this.subMenuAtivoOpen = !this.subMenuAtivoOpen) : this.subMenuAtivoOpen = false;
    this.appSharedDataService.setMenuActive(this.active);
  }

  over() {
    this.menuMobile = false;
    this.menuOver = true;
    this.toogleMenu();
  }

  out() {
    this.menuMobile = false;
    this.menuOver = false;
    this.toogleMenu();
  }

  openSobre(): void {
    this.modalService.open(SobreComponent, {
      keyboard: false,
      beforeDismiss: () => {
        return this.authenticationService.currentUserValue == null;
      },
      centered: true
    });
  }

  openContato(): void {
    this.modalService.open(ContatoComponent, {
      keyboard: false,
      beforeDismiss: () => {
        return this.authenticationService.currentUserValue == null;
      },
      centered: true
    });
  }

  addIconsMenu(ramo) {
    switch (ramo.id) {
      case RamosMenuEnum.Automovel:
        return "automovel"
      case RamosMenuEnum.Habitacional:
        return "habitacional"
      case RamosMenuEnum.Multiramo:
        return "multiramo"
      case RamosMenuEnum.Saude:
        return "saude"
      case RamosMenuEnum.Previdencia:
        return "previdencia"
      case RamosMenuEnum.Vida:
        return "vida"
      case RamosMenuEnum.Transporte:
        return "transporte"
      case RamosMenuEnum.Antifraude:
        return "antifraude"
    }
  }

  showMetodo(produto) {
    return produto.metodos.length >= 2;
  }

  isMetodoOculto(metodo: any): boolean {
    return [2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2124, 2125, 2126, 2127, 2128, 2129, 10008, 10009, 10010, 10011, 10012, 10013, 10014, 10015, 10016, 10017].includes(metodo?.id);
  }

  isSubItemStiAtivo(nameReport: string): boolean {
    return this.router.url.includes('/' + nameReport + '/');
  }

  getAcessoSubItemSti(subMenuAtivo: any, subMenu): boolean {
    if(subMenuAtivo.idProduto != 106) return true

    const metodo = subMenuAtivo?.metodos?.find((m: any) => {
      if(String(m.id) == subMenu.nameReport || String(m.id) == subMenu) return m
    });

    return metodo ? metodo.acesso : false;
  }

  hasGrupoSti(produto: any, grupo: any): boolean {
    return grupo.subItem.some(ramo => produto?.metodos?.some((m: any) => String(m.id) == ramo.nameReport));
  }

  toogleRamoGrupoSti(ramo: any) {
    this.ramoGrupoStiAberto = this.ramoGrupoStiAberto == ramo.nomePagina ? undefined : ramo.nomePagina;
  }

  isPaginaGrupoStiAtiva(ramo: any, pagina: any): boolean {
    if (!ramo.nameReport || !this.isSubItemStiAtivo(ramo.nameReport)) return false

    const paginaAtiva = ramo.subItem.find(el => el.link == this.linkGrupoSti) || ramo.subItem[0];
    return paginaAtiva == pagina;
  }

  goToGrupoSti(produto: any, pagina: any) {
    const metodo = produto?.metodos?.find((m: any) => String(m.id) == pagina.nameReport);
    if (!metodo) return

    this.linkGrupoSti = pagina.link;
    sessionStorage.setItem('reportNameDBStiGrupo', pagina.link);
    this.goToDashboard(produto, metodo, pagina);
  }

  goToConsulta(produto: any, metodo: any, subItem: any, ramoId?: string): void {

    const activeRamoId = ramoId ? ramoId : (this.meusProdutosGroup.find(el => el.open).id || 1)

    this.linkActive = metodo;
    if (subItem) {
      this.subItemPbi = subItem.nameReport;
    }

    const metodoId = (produto.idProduto == 106 && subItem?.nameReport) ? subItem.nameReport : metodo.id;

    if (produto.acesso && metodo.acesso) {
      this.router.navigate(['/consulta', activeRamoId, produto.idProduto, metodoId, produto.dsServico, metodo.dsMetodo], { queryParamsHandling: 'merge', queryParams: { favorito: produto.favorito } });
    }
    else
      this.notificationService.info('Você não possui permissão para realizar esta consulta!!!');
  }

  goToLinkExterno(acesso: any): void {
    if (!acesso)
      this.notificationService.info('Você não possui permissão para acessar este produto!!!');
  }

  validateTour() {
    this.appSharedDataService.activeTour$.subscribe((res) => {
      this.tour = res;
      if (this.tour) {
        this.parametroPortalService.getParametroPortal(this.propertyTourId).subscribe((res: any) => {
          let stepsJson = this.decodeEntities(res.valor);
          let stepsTour = []

          stepsJson.tour.forEach(x => stepsTour.push(x.step));
          this.appSharedDataService.setStepsTour(stepsTour);
          this.appSharedDataService.setStepTourJson(stepsJson.tour);

          this.titleTour = stepsJson.tour[this.arrayStepTour]?.title;
          this.descriptionTour = stepsJson.tour[this.arrayStepTour]?.description;
          this.stepsTour = stepsTour;

          this.joyrideTour.startTour({
            steps: this.stepsTour,
            stepDefaultPosition: 'right',
            showCounter: false,
            customTexts: {
              done: 'Finalizar'
            }
          }).subscribe({
            complete: () => {
              this.finalTour();
            }
          });
        })
      }
    });
  }

  finalTour(): void {
    this.usuarioService.inactiveTour(this.authenticationService.currentUserValue.id_usuario).subscribe((res) => console.log(res));
  }

  decodeEntities(str) {
    const element = document.createElement('div');
    if (str && typeof str === 'string') {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }
    return JSON.parse(str);
  }

  buscarProdutosPorRamo(ramos): void {
    let meusProdutos = this.storageService.get({ storageKey: EStorage.MENU })
    if (meusProdutos) {
      this.meusProdutosGroup = JSON.parse(JSON.stringify(meusProdutos.value));
      this.menuLoaded.emit(true)

      if (meusProdutos) {
        if (this.authenticationService.currentUser) {
          this.adicionarMenuPowerBi(this.meusProdutosGroup);
          this.addMenuDashboardAntifraude(this.meusProdutosGroup);
          this.addMenuDevPortalItems(this.meusProdutosGroup);
        }
      }

      this.appSharedDataService.menuBootstrap$.subscribe((data) => {
        this.meusProdutosGroup = JSON.parse(JSON.stringify(data));
        this.adicionarMenuPowerBi(this.meusProdutosGroup);
        this.addMenuDashboardAntifraude(this.meusProdutosGroup);
        this.addMenuDevPortalItems(this.meusProdutosGroup);
      });
    }
  }

  adicionarMenuPowerBi(menu: any) {
    if (menu.length) {
      const ramos = menu.find((automoveis: any) => automoveis.id == 1)
      const produto = ramos.produtos.find((dashboard: any) => dashboard.idProduto == 80)
      if (!(produto && produto.metodos)) return
      produto.metodos.forEach(metodo => metodo.subItem = this.produtosMenuPowerBi.find(x => x.id == metodo.id));
    } else {
      if (!(menu && menu.metodos)) return
      menu.metodos.forEach(metodo => metodo.subItem = this.produtosMenuPowerBi.find(x => x.id == metodo.id));
    }
  }

  addMenuDashboardAntifraude(menu: any) {
    if (menu.length) {
      const ramosAntifraude = menu.find((multirramo: any) => multirramo.id == 3)
      const produtoAntifraude = ramosAntifraude.produtos.find((dashboard: any) => dashboard.idProduto == 85)
      if (!(produtoAntifraude && produtoAntifraude.metodos)) return
      produtoAntifraude.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardAntifraude.find(x => x.id == metodo.id));
    } else {
      if (!(menu && menu.metodos)) return
      menu.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardAntifraude.find(x => x.id == metodo.id));
    }
  }

  addMenuDashboardSti(menu: any) {
    if (menu.length) {
      const ramosAntifraude = menu.find((antifraude: any) => antifraude.id == 8)
      const produtoSti = ramosAntifraude.produtos.find((dashboard: any) => dashboard.idProduto == 106)
      if (!(produtoSti && produtoSti.metodos)) return
      produtoSti.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardSti.find(x => x.id == metodo.id));
    } else {
      if (!(menu && menu.metodos)) return
      menu.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardSti.find(x => x.id == metodo.id));
    }
  }

  addMenuDashboardSia(menu: any) {
    if (menu.length) {
      const ramosAntifraude = menu.find((antifraude: any) => antifraude.id == 8)
      const produtoSia = ramosAntifraude.produtos.find((dashboard: any) => dashboard.idProduto == 107)
      if (!(produtoSia && produtoSia.metodos)) return
      produtoSia.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardSia.find(x => x.id == metodo.id));
    } else {
      if (!(menu && menu.metodos)) return
      menu.metodos.forEach(metodo => metodo.subItem = this.produtosMenuDashboardSia.find(x => x.id == metodo.id));
    }
  }

  addMenuDevPortalItems(menu: any) {
    if (this.authenticationService.currentUser['devMode'] !== true) {
      return;
    }
    if (menu && menu.length) {
      // AUTOMÓVEL
      let ramoAutomovelIndex = menu.findIndex((ramo: any) => ramo.id == RamosMenuEnum.Automovel);
      let ramoAutomovel;
      if (ramoAutomovelIndex === -1) {
        ramoAutomovel = {
          id: RamosMenuEnum.Automovel,
          nome: 'Automóvel',
          produtos: []
        };
        menu.push(ramoAutomovel);
      } else {
        ramoAutomovel = menu[ramoAutomovelIndex];
        ramoAutomovel.produtos = ramoAutomovel.produtos ? [...ramoAutomovel.produtos] : [];
      }

      let rnsAuto = ramoAutomovel.produtos.find((p: any) => p.idProduto == 24);
      if (rnsAuto) {
        rnsAuto.nomeProduto = 'RNS AUTO - INCLUSAO';
      }

      let rns = ramoAutomovel.produtos.find((p: any) => p.idProduto == 998);
      if (!rns) {
        let newRnsItem = {
          idProduto: 998,
          nomeProduto: 'RNS AUTO - CONSULTA',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 922,
              nome: 'RNS WS',
              acesso: true
            }
          ]
        };
        
        let rnsAutoIndex = ramoAutomovel.produtos.findIndex((p: any) => p.idProduto == 24);
        if (rnsAutoIndex !== -1) {
          ramoAutomovel.produtos.splice(rnsAutoIndex + 1, 0, newRnsItem);
        } else {
          ramoAutomovel.produtos.push(newRnsItem);
        }
      }

      // SAÚDE - SCCP
      let ramoSaudeIndex = menu.findIndex((ramo: any) => ramo.id == RamosMenuEnum.Saude);
      let ramoSaude;
      if (ramoSaudeIndex === -1) {
        ramoSaude = {
          id: RamosMenuEnum.Saude,
          nome: 'Saúde',
          produtos: []
        };
        menu.push(ramoSaude);
      } else {
        ramoSaude = menu[ramoSaudeIndex];
        ramoSaude.produtos = ramoSaude.produtos ? [...ramoSaude.produtos] : [];
      }

      let sccp = ramoSaude.produtos.find((p: any) => p.idProduto == 79);
      if (!sccp) {
        ramoSaude.produtos.push({
          idProduto: 79,
          nomeProduto: 'SCCP',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 915,
              nome: 'Consulta SCCP',
              acesso: true
            },
            {
              id: 916,
              nome: 'Cadastro SCCP',
              acesso: true
            }
          ]
        });
      }

      // TRANSPORTES - RNS Transporte
      let ramoTransporteIndex = menu.findIndex((ramo: any) => ramo.id == RamosMenuEnum.Transporte);
      let ramoTransporte;
      if (ramoTransporteIndex === -1) {
        ramoTransporte = {
          id: RamosMenuEnum.Transporte,
          nome: 'Transportes',
          produtos: []
        };
        menu.push(ramoTransporte);
      } else {
        ramoTransporte = menu[ramoTransporteIndex];
        ramoTransporte.produtos = ramoTransporte.produtos ? [...ramoTransporte.produtos] : [];
      }

      let rnsTransporte = ramoTransporte.produtos.find((p: any) => p.idProduto == 109);
      if (!rnsTransporte) {
        ramoTransporte.produtos.push({
          idProduto: 109,
          nomeProduto: 'RNS Transportes',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 918,
              nome: 'RNS Transportes WS',
              acesso: true
            }
          ]
        });
      }

      // MULTIRAMO
      let ramoMultiramoIndex = menu.findIndex((ramo: any) => ramo.id == RamosMenuEnum.Multiramo);
      let ramoMultiramo;
      if (ramoMultiramoIndex === -1) {
        ramoMultiramo = {
          id: RamosMenuEnum.Multiramo,
          nome: 'Multiramo',
          produtos: []
        };
        menu.push(ramoMultiramo);
      } else {
        ramoMultiramo = menu[ramoMultiramoIndex];
        ramoMultiramo.produtos = ramoMultiramo.produtos ? [...ramoMultiramo.produtos] : [];
      }

      let rnsCreditos = ramoMultiramo.produtos.find((p: any) => p.idProduto == 110);
      if (!rnsCreditos) {
        ramoMultiramo.produtos.push({
          idProduto: 110,
          nomeProduto: 'RNS Créditos e Garantias',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 919,
              nome: 'RNS Créditos e Garantias WS',
              acesso: true
            }
          ]
        });
      }

      let rnsPatrimonial = ramoMultiramo.produtos.find((p: any) => p.idProduto == 108);
      if (!rnsPatrimonial) {
        ramoMultiramo.produtos.push({
          idProduto: 108,
          nomeProduto: 'RNS Patrimonial',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 917,
              nome: 'RNS Patrimonial WS',
              acesso: true
            }
          ]
        });
      }

      let rnsRural = ramoMultiramo.produtos.find((p: any) => p.idProduto == 111);
      if (!rnsRural) {
        ramoMultiramo.produtos.push({
          idProduto: 111,
          nomeProduto: 'RNS Rural',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 920,
              nome: 'RNS Rural WS',
              acesso: true
            }
          ]
        });
      }

      // VIDA - RNS Pessoas
      let ramoVidaIndex = menu.findIndex((ramo: any) => ramo.id == RamosMenuEnum.Vida);
      let ramoVida;
      if (ramoVidaIndex === -1) {
        ramoVida = {
          id: RamosMenuEnum.Vida,
          nome: 'Vida',
          produtos: []
        };
        menu.push(ramoVida);
      } else {
        ramoVida = menu[ramoVidaIndex];
        ramoVida.produtos = ramoVida.produtos ? [...ramoVida.produtos] : [];
      }

      let rnsPessoas = ramoVida.produtos.find((p: any) => p.idProduto == 112);
      if (!rnsPessoas) {
        ramoVida.produtos.push({
          idProduto: 112,
          nomeProduto: 'RNS Pessoas',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 921,
              nome: 'RNS Pessoas WS',
              acesso: true
            }
          ]
        });
      }

      // Remove all RNS Coincidências from the backend and inject exactly ONE correct one
      if (ramoVida && ramoVida.produtos) {
        let firstIndex = ramoVida.produtos.findIndex((p: any) => p.nomeProduto && p.nomeProduto.toLowerCase().includes('rns coincid'));
        
        ramoVida.produtos = ramoVida.produtos.filter((p: any) => {
          if (p.nomeProduto && p.nomeProduto.toLowerCase().includes('rns coincid')) {
            return false; // remove all
          }
          return true; // keep others
        });

        let correctRnsCoincidencias = {
          idProduto: 78,
          nomeProduto: 'RNS Coincidências',
          acesso: true,
          ativo: false,
          metodos: [
            {
              id: 9999,
              nome: 'RNS Coincidências WS',
              acesso: true
            }
          ]
        };

        if (firstIndex !== -1) {
          ramoVida.produtos.splice(firstIndex, 0, correctRnsCoincidencias);
        } else {
          ramoVida.produtos.push(correctRnsCoincidencias);
        }
      }
    }
  }

  createBorder(event): void {
    let eventClass = event.target.classList;
    if (this.tour) {
      if (eventClass.contains('next'))
        this.counterSteps++
      else if (eventClass.contains('back'))
        this.counterSteps--
      else
        this.counterSteps

      setTimeout(() => {
        this.borderTour();
      }, 5)
    }
  }

  borderTour(): void {
    let e = document.querySelector("div.backdrop-target");
    if (e) {
      switch (this.counterSteps) {
        case StepsTourEnum.menuBootstrapStep:
          e.innerHTML = "<div class='b-tour b-tour-top-left'><div>";
          break;
        case StepsTourEnum.headerStep:
          e.innerHTML = "<div class='b-tour headerStep b-tour-top-left'></div><div class='b-tour headerStep b-tour-bottom-left'></div><div class='b-tour headerStep b-tour-top-right'></div><div class='b-tour headerStep b-tour-bottom-right'></div>";
          break;
      }
    }
  }

  goToProdutos(ramo): void {
    this.router.navigate([`/dashboard/${ramo.id}/produtos`]);
  }

  goToForumSti(metodo: any) {
    metodo?.acesso ? window.open('https://sti.cnseg.org.br', '_blank') :
      this.notificationService.info('Você não possui permissão para acessar este produto!!!');
  }
}
